// extracted by mini-css-extract-plugin
export default {"dropdown":"_-web-client-js-react-components-___WTFSearchDropdown-module__dropdown___0aBak"};